<template>
  <div class="SideMenu">
    <div class="SideMenu__Hamburger"></div>
    <div class="SideMenu__Rest">
      <div
        class="SideMenu__Link"
        :class="getItemClass(category)"
        v-for="category in categories"
        :key="category.name"
        @click="handleClick(category)"
      >
        <Picture :name="category.name" style="width: 35px;" />
      </div>
    </div>
  </div>
</template>
<script>
import { categories } from './links';
import { Picture } from 'daas-components';
export default {
  name: 'SideMenu',
  components: {
    Picture,
  },
  data() {
    return {
      categories,
    };
  },
  methods: {
    closeMenu() {
      this.$emit('closeMenu');
    },
    openMenu() {
      this.$emit('openMenu');
    },
    handleClick(category) {
      this.$emit('setActiveItem', category.name);
      if (this.active === category.name && this.isOpen) this.closeMenu();
      else this.openMenu();
      this.$router.replace(`${'/'}${category.name}`);
    },
    getItemClass(category) {
      const isActive =
        this.active === category.name ||
        category.nestedRoutes.includes(this.active);
      return { 'SideMenu__Link--active': isActive };
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.SideMenu {
  @include z-index(SideMenu);
  background: $blue-800;
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: rem($side-menu-width);
  position: fixed;
  width: $side-menu-width;
  &__Hamburger {
    background: $toggler-gradient;
    height: rem(60);
  }
  &__Rest {
    height: 100%;
    width: 100%;
  }
  &__Link {
    cursor: pointer;
    display: flex;
    height: rem(60);
    justify-content: center;
    width: 100%;
    &:hover {
      background: $black-400;
    }

    &--active {
      background: $black-400;

      &::before {
        background-image: $active-category-gradient;
        content: '';
        height: rem(60);
        left: 0;
        position: absolute;
        width: rem(3);
      }
    }
  }
}
</style>
